export const STANDARD_CSV = [
    [
        'Well_Name',
        'Rig_Name',
        'Well_Field',
        'Well_Type',
        'Well_Water_Depth',
        'Well_Category',
        'Well_Geodetic_Reference_System',
        'Well_Latitude',
        'Well_Longitude',
        'Intervention_Name',
        'Intervention_Tactic',
        'Intervention_Responsible',
        'Intervention_Start_Date',
        'Intervention_Start_Hour',
        'Intervention_End_Date',
        'Intervention_End_Hour',
        'Section_Name',
        'Section_OD',
        'Section_Start_MD',
        'Section_Final_MD',
        'Section_Start_Date',
        'Section_Start_Hour',
        'Section_End_Date',
        'Section_End_Hour',
        'Section_Prev_Casing_OD',
        'Section_Prev_Casing_Final_MD',
        'Section_Type',
        'Section_Riser',
        'Rig_Table_Status_Type',
        'Rig_Table_Status_Reason',
        'Rig_Start_Date',
        'Rig_Start_Hour',
        'Rig_End_Date',
        'Rig_End_Hour',
        'Run_Number',
        'Run_Start_MD',
        'Run_Final_MD',
        'Run_Start_Date',
        'Run_Start_Hour',
        'Run_End_Date',
        'Run_End_Hour',
        'Run_Type',
        'Run_Extend_Last_Tubular',
        'Run_Tubulars_interval_per_time',
        'Run_Cement_Plug_Start_MD',
        'Run_Cement_Plug_Final_MD',
        'Tubular_Type',
        'Tubular_Connection_Type',
        'Tubular_Permanent_Tubular_Installation',
        'Tubular_OD',
        'Tubular_Start_MD',
        'Tubular_Final_MD',
        'Third_Party_Responsible',
        'Tubular_Material_Type',
        'Tubular_Start_Date',
        'Tubular_Start_Hour',
        'Tubular_End_Date',
        'Tubular_End_Hour',
        'Tubular_Restricted_Pipe_Movement_Type',
        'Tubular_Restricted_Pipe_Movement_Goal_Acronym',
        'Tubular_Restricted_Pipe_Movement_Goal_Uom',
        'Tubular_Restricted_Pipe_Movement_Goal_Value',
        'Tubular_Restricted_Pipe_Movement_Start_MD',
        'Tubular_Restricted_Pipe_Movement_Final_MD',
        'Tubular_Restricted_Pipe_Movement_Start_Date',
        'Tubular_Restricted_Pipe_Movement_Start_Hour',
        'Tubular_Restricted_Pipe_Movement_End_Date',
        'Tubular_Restricted_Pipe_Movement_End_Hour',
        'Tubular_Restricted_Connection_Type',
        'Tubular_Restricted_Connection_Goal_Acronym',
        'Tubular_Restricted_Connection_Goal_Uom',
        'Tubular_Restricted_Connection_Goal_Value',
        'Tubular_Restricted_Connection_Start_MD',
        'Tubular_Restricted_Connection_Final_MD',
        'Tubular_Restricted_Connection_Start_Date',
        'Tubular_Restricted_Connection_Start_Hour',
        'Tubular_Restricted_Connection_End_Date',
        'Tubular_Restricted_Connection_End_Hour',
        'Tubular_Restricted_ROP_Type',
        'Tubular_Restricted_ROP_Goal_Acronym',
        'Tubular_Restricted_ROP_Goal_Uom',
        'Tubular_Restricted_ROP_Goal_Value',
        'Tubular_Restricted_ROP_Start_MD',
        'Tubular_Restricted_ROP_Final_MD',
        'Tubular_Restricted_ROP_Start_Date',
        'Tubular_Restricted_ROP_Start_Hour',
        'Tubular_Restricted_ROP_End_Date',
        'Tubular_Restricted_ROP_End_Hour'
    ],
    [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
    ]
]
